var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttributesadmin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3759",
    "data-name": "Rectangle 3759",
    width: 24,
    height: 24,
    transform: "translate(60 479)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_4729",
    "data-name": "Mask Group 4729",
    transform: "translate(-60 -479)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_431",
    "data-name": "Ellipse 431",
    transform: "translate(62 481)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7592",
    "data-name": "Group 7592"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_784",
    "data-name": "Line 784",
    y2: 8,
    transform: "translate(72 487)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_785",
    "data-name": "Line 785",
    y2: 8,
    transform: "translate(76 491) rotate(90)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttributesadmin);
export default __webpack_public_path__ + "static/media/attributesadmin.739bc1070760bdf699a1d5afd165947c.svg";
export { ForwardRef as ReactComponent };